// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__1ELw6","title":"card_title__zNbqJ","inActive":"card_inActive__uRE1M"};